import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { hasMembershipInCommunity } from '../../user-roles';
import {
  canCreatePostInCommunity,
  canInviteToCommunity,
  canLeaveCommunity,
  canLeaveCommunityDetail,
  canManageCommunity,
  canManageCommunityAssets,
  canManageCommunityDetail,
  canManageSelectedCommunity,
  canViewAdminDashboardCommunities,
  canViewCommunityMembers,
} from '../permissions';

export const useCommunitiesPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canCreatePostInCommunity: bindViewer(canCreatePostInCommunity),
      canInviteToCommunity: bindViewer(canInviteToCommunity),
      canLeaveCommunity: bindViewer(canLeaveCommunity),
      canLeaveCommunityDetail: bindViewer(canLeaveCommunityDetail),
      canManageCommunity: bindViewer(canManageCommunity),
      canManageCommunityAssets: bindViewer(canManageCommunityAssets),
      canManageCommunityDetail: bindViewer(canManageCommunityDetail),
      canManageSelectedCommunity: bindViewer(canManageSelectedCommunity),
      canViewAdminDashboardCommunities: bindViewer(canViewAdminDashboardCommunities),
      canViewCommunityMembers: bindViewer(canViewCommunityMembers),
      hasMembershipInCommunity: bindViewer(hasMembershipInCommunity),
    }),
    [bindViewer],
  );
};
